<template>
    <div class="">
        <v-label>{{label}} (QR)</v-label>
        <div class="py-2">
            <v-btn class="primary" @click="dialog=true">{{field.etiqueta}}</v-btn>
        </div>
        <v-textarea
            outlined
            v-if="field.extra.qr_text_area == 1"
            v-model="formValues[field.nombre]"
        />
        <!---->

        <v-dialog
            v-if="dialog"
            v-model="dialog"
            persistent
            max-width="600px"
            :fullscreen="this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name==='sm'"
        >
            <v-card>
                <v-card-title>
                    <span class="headline">{{field.etiqueta}}</span>
                </v-card-title>
                <v-card-text>
                    <StreamBarcodeReader
                        @decode="onDecode"
                        @loaded="onLoaded"
                    ></StreamBarcodeReader>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialog = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <template v-if="createHtmlRequest">
            <form :action="submitUrl" :method="field.extra.method" :target="formTarget">
                <input type="text" v-for="item in this.field.datos" :name="getInputName(item.etiqueta)" :key="item.valor" :value="item.valor">
                <input type="submit" value="Submit" ref="submitButton">
            </form>
        </template>
    </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    name: "TextField",
    props: ['field', 'readonly', 'label', 'formValues'],

    data() {
        return {
            rules: [],
            dialog: false,
            createHtmlRequest: false,
            submitUrl: '',
            formTarget: ''
        }
    },
    components: {
        StreamBarcodeReader
    },

    mounted() {
        console.log(this.$refs)
    },

    methods: {
        onDecode(result){
            if (this.field.extra.qr_auto_close == 1){
                this.dialog = false
            }

            this.showQRValue(result)
            this.validateAndRedirectUrl(result)
        },
        onLoaded(){

        },

        showQRValue(value){
            if (this.field.extra.qr_text_area == 1){
                this.formValues[this.field.nombre] = value
            }
        },

        validateAndRedirectUrl(value){
            if (this.field.extra.qr_redirect == 1 && /^(?:\w+:)?\/\/([^\s\\.]+\.\S{2}|localhost[\\:?\d]*)\S*$/.test(value)){
                this.formTarget = this.field.extra.qr_redirect_blank == 1 ? '_blank' : ''
                this.submitUrl = value
                this.createHtmlRequest = true

                let vueApp = this
                setTimeout(function (){
                    vueApp.redirectUrl()
                }, 200)
            }
        },

        getInputName(itemName){
            return itemName.replace(' ', '_')
        },

        redirectUrl(){
            this.$refs.submitButton.click()
        }
    }
}
</script>